<template>
  <div class="card" v-show="currentCardId == 'license-history'">
    <div class="overflow-scroll-y">
      <div class="card-header">
        <h2>免許・資格を入力</h2>
        <p>主要な免許・資格は例文から選ぶことができます</p>
      </div>
      <div class="card-content-list">
        <div class="add-item">
          <el-button type="success" @click="exampleVisible = true"
            >例文から追加</el-button
          >
          <NewRirekishoExampleSentenceDialog
            :value="exampleVisible"
            name="license-dialog"
            :items="licenseExamples"
            @input="exampleVisible = $event"
            @select="onSelectExample"
          />
        </div>
        <div class="edit-form-list">
          <transition-group name="fade" tag="div">
            <HistoryItem
              v-for="(item, index) in formatData.licenseHistories"
              :key="item.uuid"
              :item="item"
              :length="formatData.licenseHistories.length"
              :index="index"
              :id="item.uuid"
              :class="{ active: activeHistoryItem == item.uuid }"
              :minYear="basicData.birthYear"
              :createDate="formatData.createDate"
              :descriptionPlaceholder="'免許・資格を入力'"
              :descriptionMaxLength="descriptionMaxLength"
              @add-history-item="addLicenseHistory"
              @delete-history-item="deleteLicenseHistory"
              @move-history-item="moveLicenseHistory"
              @click.native="activateHistoryItem(item.uuid)"
            />
          </transition-group>
          <div class="add-list-item">
            <el-button
              icon="el-icon-plus"
              circle
              type="success"
              @click="addLicenseHistory()"
            />
          </div>
          <div
            class="attention-limit column"
            v-if="previewErrors.licenseHistory"
          >
            <i class="el-icon-warning"></i> {{ previewErrors.licenseHistory }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed, ref } from 'vue'
import HistoryItem from '@/components/formats/RirekishoParts/HistoryItem.vue'
import NewRirekishoExampleSentenceDialog from '@/components/format-edit/new-rirekisho/NewRirekishoExampleSentenceDialog.vue'
import {
  useNewRirekishoFormatData,
  type NewRirekishoExampleSentence,
  type NewRirekishoExampleSentences
} from '@/composables/format-edit/useNewRirekishoFormatData'
import { useNewRirekishoHistoriesApi } from '@/composables/format-edit/useNewRirekishoHistories'

const descriptionMaxLength = 80

const props = defineProps<{
  currentCardId?: string
  basicData: Record<string, unknown>
  previewErrors: Record<string, string>
  exampleSentences?: NewRirekishoExampleSentences
}>()

const formatData = useNewRirekishoFormatData()
const {
  activeHistoryItem,
  addLicenseHistory,
  deleteLicenseHistory,
  moveLicenseHistory,
  activateHistoryItem
} = useNewRirekishoHistoriesApi()

const exampleVisible = ref(false)

const licenseExamples = computed(() => props.exampleSentences?.license || [])

function onSelectExample(item: NewRirekishoExampleSentence) {
  addLicenseHistory(null, { description: item.description })
}
</script>
